import {Component, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import { Router } from '@angular/router';

import { fuseAnimations } from '@fuse/animations';
import {User} from "../models";
import {WorkTimeService} from "./service/workTime.service";
import {first} from "rxjs/operators";
import {WorkTimeSummaryList} from "./model/workTimeSummaryList";
import {AlertService} from "../services";
import {MatDialog} from "@angular/material/dialog";
import {WorkTimeDetailsDialogComponent} from "./dialog/workTimeDetails.component";
import {WorkTimeReportDialogComponent} from "../report/workTime/dialog/workTimeReportDialog.component";

@Component({
    selector     : 'work-time',
    templateUrl  : './workTime.component.html',
    styleUrls    : ['./workTime.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class WorkTimeComponent implements OnInit, OnDestroy
{
    @Input() user: User;
    @Input() title: string = 'Time in club';
    workTimeSummaryList: WorkTimeSummaryList = {items: []};
    countedWorkTime: Array<any> = [];
    dialogRef: any;

    constructor(
        private _router: Router,
        private _workTimeService: WorkTimeService,
        private _alertService: AlertService,
        public _matDialog: MatDialog,
    )
    {
        this.countedWorkTime = [];
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {

        let today = new Date();
        let fromDate = this.convertDateToString(new Date(today.setDate(today.getDate()-31)));
        let toDate = this.convertDateToString(new Date());

        this._workTimeService.getByUserAndTimeSpan(this.user, fromDate, toDate).pipe(first())
            .subscribe((res: WorkTimeSummaryList) => {
                    this.workTimeSummaryList = res;
                    let total = this.workTimeSummaryList.items.length;
                    let foundElement = false;

                    for (let i = 0; i<total; i++) {
                        let key = this.workTimeSummaryList.items[i].day + "." + this.workTimeSummaryList.items[i].month + '.' + this.workTimeSummaryList.items[i].year;
                        let j=0;
                        for (j; j<this.countedWorkTime.length; j++) {
                            if (this.countedWorkTime[j].date === key) {
                                foundElement = true;
                                break;
                            }
                        }

                        if (!foundElement) {
                            this.countedWorkTime.push({
                                detailsDate: this.workTimeSummaryList.items[i].year + "-" + this.workTimeSummaryList.items[i].month + '-' + this.workTimeSummaryList.items[i].day,
                                date: key,
                                timeInSeconds: 0,
                                timeInMinutes: 0,
                                timeInHours: 0,
                                timeInString: '0h 0m 0s'
                            });

                            j = this.countedWorkTime.length-1;
                        }

                        let seconds = this.countedWorkTime[j].timeInSeconds + this.workTimeSummaryList.items[i].timeISeconds;
                        let hours = Math.round(seconds/3600);
                        let s = seconds%3600;
                        let minutes = Math.round(s/60);
                        s = s%60;

                        this.countedWorkTime[j] = {
                            detailsDate: this.workTimeSummaryList.items[i].year + "-" + this.workTimeSummaryList.items[i].month + '-' + this.workTimeSummaryList.items[i].day,
                            date: key,
                            timeInSeconds: this.countedWorkTime[j].timeInSeconds + this.workTimeSummaryList.items[i].timeISeconds,
                            timeInMinutes: this.countedWorkTime[j].timeInMinutes + Math.floor(this.workTimeSummaryList.items[i].timeISeconds*100/60)/100,
                            timeInHours: this.countedWorkTime[j].timeInHours + Math.floor(this.workTimeSummaryList.items[i].timeISeconds*100/3600)/100,
                            timeInString: hours + 'h ' + minutes + 'm ' + s + 's',
                        };

                        foundElement = false;
                    }
                },
                error => {
                    this._alertService.error(error);
                })
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {

    }

    convertDateToString(date: Date): string {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [date.getFullYear(),
            (mm>9 ? '' : '0') + mm,
            (dd>9 ? '' : '0') + dd
        ].join('-');
    };

    showWorkTimeDetailsDialog(user: User, date: string) {
        this.dialogRef = this._matDialog.open(WorkTimeReportDialogComponent, {
            panelClass: 'work-time-report-dialog',
            data      : {
                action : 'details',
                userId: user.id,
                fromDate: date,
                toDate: date,
            },
            width: '450px',
        });

        this.dialogRef.afterClosed()
            .subscribe(() => {
                this.dialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }
}
